import { IPageConfig, getAllPagesConfig, getAllPagesConfigWithCustomTokenAndPages } from '@/services/page-config-service';
import { GetLoggedInUserRolePages, GetLoggedInUserRolePagesWithCustomToken } from '@/services/user-service';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

export const pageConfigSliceInitialState: PageConfigSliceDataType = {
  publicRoutes: [],
  protectedRoutes: [],
  allRoutePaths: [],
};

const pageConfigSlice = createSlice({
  name: 'pageConfig',
  initialState: pageConfigSliceInitialState,
  reducers: {
    updatePageConfigOnCreateNewPage: (state, action: PayloadAction<IPageConfig | null>) => {
      if (action.payload?.isPublicRoute === true) state.publicRoutes = [...state.publicRoutes, action.payload];
      else if (action.payload?.isPublicRoute === false) state.protectedRoutes = [...state.protectedRoutes, action.payload];
      state.allRoutePaths = [...state.publicRoutes, ...state.protectedRoutes].map((item) => item.path);
    },
    updatePageConfigOnUpdateExistingPage: (state, action: PayloadAction<IPageConfig | null>) => {
      if (action.payload?.isPublicRoute === true) state.publicRoutes = state.publicRoutes.map((item) => (item._id === action.payload?._id ? action.payload : item));
      else if (action.payload?.isPublicRoute === false) state.protectedRoutes = state.protectedRoutes.map((item) => (item._id === action.payload?._id ? action.payload : item));
      state.allRoutePaths = [...state.publicRoutes, ...state.protectedRoutes].map((item) => item.path);
    },
    updatePageConfigOnDeletePage: (state, action: PayloadAction<IPageConfig | null>) => {
      if (action.payload?.isPublicRoute === true) state.publicRoutes = state.publicRoutes.filter((item) => Boolean(item._id !== action.payload?._id));
      else if (action.payload?.isPublicRoute === false) state.protectedRoutes = state.protectedRoutes.filter((item) => Boolean(item._id !== action.payload?._id));
      state.allRoutePaths = [...state.publicRoutes, ...state.protectedRoutes].map((item) => item.path);
    },
  },
  extraReducers: (builder) => {
    // Add type assertion for response.data
    builder.addCase(getPagesConfigThunk.fulfilled, (state, action) => {
      const routes = action.payload.routes as IPageConfig[];
      state.publicRoutes = routes.filter((item) => Boolean(item.isEnabled && item.isPublicRoute));
      state.protectedRoutes = routes.filter((item) => Boolean(item.isEnabled && !item.isPublicRoute));
      state.allRoutePaths = routes.map((item) => item.path);
    });

  },
});

export const { updatePageConfigOnCreateNewPage, updatePageConfigOnUpdateExistingPage, updatePageConfigOnDeletePage } = pageConfigSlice.actions;
export default pageConfigSlice.reducer;
export interface PageConfigSliceDataType {
  publicRoutes: IPageConfig[];
  protectedRoutes: IPageConfig[];
  allRoutePaths: string[];
}

export const getPagesConfigThunk = createAsyncThunk('pageConfig/getPagesConfigThunk', async (data: { token: string | null; userRole: string }) => {
  let roleResponse: AxiosResponse<any, any> | undefined;
  if (!!data.userRole) roleResponse = !!data.token ? await GetLoggedInUserRolePagesWithCustomToken({ title: data.userRole }, { token: data.token }) : await GetLoggedInUserRolePages({ title: data.userRole });
  // const response = !!data.token && !!roleResponse ? await getAllPagesConfigWithCustomTokenAndPages({ token: data.token }, { pagesId: roleResponse.data[0].pages.map((item) => item.pageId) }) : await getAllPagesConfig();
  const response = !!data.token && !!roleResponse ? await getAllPagesConfig() : await getAllPagesConfig();
  return response.data ? { version: 0, routes: response.data || [] } : { version: 0, routes: [] };
});
